import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, TextField, Button, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import CategoryIcon from '@mui/icons-material/Category';

const CategoryForm = ({ selected, onSuccess, onCancel }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selected) setName(selected.name);
    else setName('');
  }, [selected]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (selected) {
        await axios.put(`/api/categories/${selected.id}`, { name });
      } else {
        await axios.post('/api/categories', { name });
      }
      onSuccess();
      setName('');
    } catch (error) {
      console.error('Error saving category:', error);
      alert('Failed to save category');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1, 
        bgcolor: '#1976d2',
        color: 'white',
        fontSize: '1rem',
        py: 1.5
      }}>
        <CategoryIcon />
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem' }}>
          {selected ? 'Edit Category' : 'Add New Category'}
        </Typography>
      </DialogTitle>
      
      <DialogContent dividers>
        <Box component="form" id="category-form" onSubmit={handleSubmit} sx={{ pt: 2 }}>
          <TextField
            fullWidth
            value={name}
            onChange={e => setName(e.target.value)}
            label="Category Name"
            placeholder="Enter category name"
            required
            autoFocus
            variant="outlined"
            sx={{ 
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#1a237e',
                }
              }
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ py: 1, px: 2, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'grey.50', gap: 1 }}>
        <Button 
          onClick={onCancel}
          variant="outlined"
          startIcon={<CancelIcon />}
          sx={{ 
            borderColor: '#757575',
            color: '#757575',
            '&:hover': {
              borderColor: '#424242',
              bgcolor: '#f5f5f5'
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          type="submit"
          form="category-form"
          variant="contained" 
          disabled={loading}
          startIcon={selected ? <EditIcon /> : <AddIcon />}
          sx={{ 
            bgcolor: '#1976d2',
            fontSize: '0.75rem',
            py: 0.5,
            px: 1.5,
            '&:hover': {
              bgcolor: '#1565c0'
            }
          }}
        >
          {selected ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </>
  );
};

export default CategoryForm;
